import analytics from "@react-native-firebase/analytics";
import firebase from "@react-native-firebase/app";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Sentry from "@sentry/react-native";

import { PlatformType } from "./platform";

export function initializeFirebase(platformType: PlatformType): void {
  // Set AsyncStorage for Firebase
  firebase.setReactNativeAsyncStorage(AsyncStorage);

  // @react-native-firebase automatically initializes from native config files:
  // - iOS: GoogleService-Info.plist (or GoogleService-Info-dev.plist)
  // - Android: google-services.json (or google-services-dev.json)
  // These files are configured in app.config.js and contain all required Firebase credentials

  // Check if Firebase is already initialized
  if (firebase.apps.length > 0) {
    return; // Already initialized
  }

  // For web platform, we would need manual initialization with full credentials including apiKey
  if (platformType === PlatformType.WEB) {
    // TODO: Add web Firebase initialization if needed
    // eslint-disable-next-line no-console
    console.warn("Firebase web initialization not yet implemented");
  }
}

/**
 * Logs Firebase initialization completion for monitoring purposes.
 * Captures any errors to Sentry for debugging.
 */

export async function logFirebaseInitialization(): Promise<void> {
  // This will fails if the initialization didn't succeed.
  try {
    await analytics().logEvent("firebase_initialized");
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error logging Firebase event:", error);
    Sentry.captureException(error);
  }
}

export async function configureAnalyticsUser(
  username: string | null | undefined,
): Promise<void> {
  if (username !== null && username !== undefined) {
    await analytics().setUserId(username);
    await analytics().setUserProperties({
      username: username,
    });
  }
}
